import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useFeatures } from '@atc/features';

import {
    WALLET_GET_DEAL_DETAILS_COMPLETED,
    WALLET_GET_DEAL_DETAILS_REQUEST,
    WALLET_VALIDATE_DEALS_BY_VIN_REQUEST,
    WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED,
    debugWallet,
} from 'wallet-manager';

import { eventBus } from '@atc/cai-event-bus';

const useDealerDealInitialization = ({ paymentsDuck, dealsDuck }) => {
    const dispatch = useDispatch();

    const {
        active_deals_my_wallet: [enableActiveDeals],
    } = useFeatures(['active_deals_my_wallet']);

    const displayModal = useSelector(paymentsDuck.selectors.getDisplayMyWalletModal);

    // NOTE: Logic to determine when to fetch dr deal details
    const isInitialFetch = useRef(true);

    const localDealDetails = useRef({});

    const walletId = useSelector(paymentsDuck?.selectors?.getWalletId);

    function setDealDetails(data = []) {
        if (data?.length) {
            dispatch(dealsDuck?.creators?.setDealDetails(data));
            dispatch(dealsDuck?.creators?.updateDealNotifications(data));
        }
    }

    function validateDealsByVin(dealDetailsToValidate) {
        localDealDetails.current = dealDetailsToValidate;

        const dealVins = dealDetailsToValidate?.map((deal) => deal?.vehicle?.vin || null) || [];

        debugWallet('deals > vins to validate', dealVins);

        eventBus.emit(WALLET_VALIDATE_DEALS_BY_VIN_REQUEST, dealVins);
    }

    function mergeValidatedDeals(validatedDeals = []) {
        debugWallet('deals > validated vins', validatedDeals);
        // Adds only validated deals
        const mergedDealDetails = validatedDeals?.reduce((acc, { vin, vdpUrl }) => {
            const matchingDeal = localDealDetails?.current?.find((deal) => deal?.vehicle?.vin === vin);

            if (matchingDeal) {
                const mergedDeal = {
                    ...matchingDeal,
                    vehicle: {
                        ...matchingDeal?.vehicle,
                        vdpUrl,
                    },
                };

                acc.push(mergedDeal);
            }

            return acc;
        }, []);

        setDealDetails(mergedDealDetails);
    }

    useEffect(() => {
        if (enableActiveDeals) {
            eventBus.on(WALLET_GET_DEAL_DETAILS_COMPLETED, validateDealsByVin);

            eventBus.on(WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED, mergeValidatedDeals);

            return () => {
                eventBus.off(WALLET_GET_DEAL_DETAILS_COMPLETED, validateDealsByVin);
                eventBus.off(WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED, mergeValidatedDeals);
            };
        }

        return () => {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (enableActiveDeals) {
            if (walletId && isInitialFetch?.current) {
                eventBus.emit(WALLET_GET_DEAL_DETAILS_REQUEST, { walletId });
                isInitialFetch.current = false;
            }

            if (walletId && !isInitialFetch?.current && displayModal) {
                eventBus.emit(WALLET_GET_DEAL_DETAILS_REQUEST, { walletId });
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayModal, walletId]);

    return null;
};

export default useDealerDealInitialization;
